module.exports = __webpack_public_path__ + "img/trolley.4776625d.png";